import { render, staticRenderFns } from "./AltEanWarning.vue?vue&type=template&id=0bf4183d"
import script from "./AltEanWarning.vue?vue&type=script&lang=js"
export * from "./AltEanWarning.vue?vue&type=script&lang=js"
import style0 from "./AltEanWarning.vue?vue&type=style&index=0&id=0bf4183d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports